import { render, staticRenderFns } from "./ProjectsSettings.vue?vue&type=template&id=6ddd8056&scoped=true&"
import script from "./ProjectsSettings.vue?vue&type=script&lang=js&"
export * from "./ProjectsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddd8056",
  null
  
)

export default component.exports